import { computed, ComputedRef } from 'vue'

import { SubParticipant } from '@collector/sportsapi-types'

import { useEventSettings } from './useEventSettings'
import { useSubParticipants } from './useSubParticipants'

export function useInvertedSubParticipants(): {
  invertedSubParticipants: ComputedRef<boolean>
  firstSubParticipants: ComputedRef<SubParticipant[]>
  secondSubParticipants: ComputedRef<SubParticipant[]>
  setFirstSubParticipants(newSubParticipants: SubParticipant[]): void
  setSecondSubParticipants(newSubParticipants: SubParticipant[]): void
} {
  const { eventSettings } = useEventSettings()
  const {
    homeSubParticipants,
    awaySubParticipants,
    setHomeSubParticipants,
    setAwaySubParticipants,
  } = useSubParticipants()

  const invertedSubParticipants = computed(
    () => eventSettings.value.invertedParticipants ?? false,
  )

  const firstSubParticipants = computed(() =>
    invertedSubParticipants.value
      ? awaySubParticipants.value
      : homeSubParticipants.value,
  )

  const secondSubParticipants = computed(() =>
    invertedSubParticipants.value
      ? homeSubParticipants.value
      : awaySubParticipants.value,
  )

  const setFirstSubParticipants = (
    newSubParticipants: SubParticipant[],
  ): void => {
    if (invertedSubParticipants.value) {
      setAwaySubParticipants(newSubParticipants)
    } else {
      setHomeSubParticipants(newSubParticipants)
    }
  }

  const setSecondSubParticipants = (
    newSubParticipants: SubParticipant[],
  ): void => {
    if (invertedSubParticipants.value) {
      setHomeSubParticipants(newSubParticipants)
    } else {
      setAwaySubParticipants(newSubParticipants)
    }
  }

  return {
    invertedSubParticipants,
    firstSubParticipants,
    secondSubParticipants,
    setFirstSubParticipants,
    setSecondSubParticipants,
  }
}
